module.exports = __webpack_public_path__ + "img/block-left-medium.52ae1ede.png";